import {ConfirmationModal} from '@freckle/educator-materials/ts/components/confirmation-modal'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {exitModal} from './exit-modal.module.scss'

type Props = {
  show: boolean
  yesText: string
  onLeave: () => void
  onCancel: () => void
}

export default function ExitModal(props: Props) {
  const {show, onCancel, onLeave, yesText} = props
  const {t} = useSafeTranslation()

  return (
    <ConfirmationModal
      title={t('EXIT_MODAL_TITLE')}
      showModal={show}
      yesText={yesText}
      noText={t('EXIT_MODAL_BUTTON_NO')}
      onClickYes={onLeave}
      onClose={onCancel}
      className={exitModal}
    >
      {t('EXIT_MODAL_WARNING')}
    </ConfirmationModal>
  )
}
